import {
  concat, findIndex, insert, merge, propEq, reject
} from 'ramda';
import {
  WORK_SITES_FAIL,
  WORK_SITES_REQUEST,
  WORK_SITES_SUCCESS,
  SUBMIT_REQUEST,
  SUBMIT_FAIL,
  SUBMIT_SUCCESS,
  UPDATE_FAIL,
  UPDATE_SUCCESS,
  UPDATE_REQUEST,
  DELETE_FAIL,
  DELETE_SUCCESS,
  DELETE_REQUEST
} from 'src/store/actions/workSiteActions';

const initialState = {
  fetching: false,
  list: [],
  options: [],
  errors: []
};

const replaceInList = (site, list) => insert(findIndex(propEq('Id', site.Id), list), site, reject(propEq('Id', site.Id), list));

const workSiteReducer = (state = initialState, action) => {
  switch (action.type) {
    case WORK_SITES_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case WORK_SITES_SUCCESS:
      return merge(state, {
        list: action.workSites,
        options: action.workSites.map(({ Id, Name }) => ({ label: Name, value: Id.toString() })),
        fetching: false,
        errors: []
      });
    case WORK_SITES_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case SUBMIT_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case SUBMIT_SUCCESS:
      return merge(state, { list: concat(state.list, [action.workSite]), fetching: false, errors: [] });
    case SUBMIT_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case UPDATE_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case UPDATE_SUCCESS:
      return merge(state, { list: replaceInList(action.workSite, state.list), fetching: false, errors: [] });
    case UPDATE_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case DELETE_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case DELETE_SUCCESS:
      return merge(state, { list: reject(propEq('Id', action.workSiteId), state.list), fetching: false, errors: [] });
    case DELETE_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default workSiteReducer;
